'use strict';

import Checkbox from "./Checkbox";
import { TYPES } from "../../../hooks/useSearchFilters";

export default function CheckboxList({
    type = [TYPES.CHECKBOX, TYPES.RADIO][0],
    keyPrefix,
    items,
    maxVisible = 6,
    isExpandedInitial = false,
    isChecked,
    onChange
}) {

    const hiddenItemsRef = React.useRef()
    const [isExpanded, setIsExpanded] = React.useState(isExpandedInitial);

    React.useEffect(() => {
        if (hiddenItemsRef && hiddenItemsRef.current) {
            if (isExpanded)
                $(hiddenItemsRef.current).stop(true, true).slideDown()
            else
                $(hiddenItemsRef.current).stop(true, true).slideUp()
        }
    }, [isExpanded])

    const onExpandClick = () => {
        setIsExpanded(!isExpanded)
    }

    // Сортируем по активности (сначала с количеством, а без количества)
    const isActive = (a) => isChecked(a) || a.count > 0
    const sortedItems = items.toSorted((a, b) => (isActive(a) === isActive(b)) ? 0 : isActive(a) ? -1 : 1);
    
    const hasHiddenItems = (items || []).length > maxVisible
    const visibleItems = (sortedItems || []).slice(0, maxVisible);
    const hiddenItems = (sortedItems || []).slice(maxVisible);

    return <React.Fragment>
        {visibleItems.map((e) => {
            return <Checkbox
                type={type}
                key={`${keyPrefix}-${e.id}`}
                title={e.title}
                count={e.count}
                price={e.price}
                currency={e.currency}
                isChecked={isChecked({id: e.id})}
                isDisabled={e.count === 0}
                onChange={(value) => onChange({id: e.id, value: value})}
            />
        })}
        {hasHiddenItems && <div ref={hiddenItemsRef} className='el__filter-toggle'>
            {(hiddenItems || []).map((e) => {
                return <Checkbox
                    type={type}
                    key={`${keyPrefix}-${e.id}`}
                    title={e.title}
                    count={e.count}
                    price={e.price}
                    currency={e.currency}
                    isChecked={isChecked({id: e.id})}
                    isDisabled={e.count === 0}
                    onChange={(value) => onChange({id: e.id, value: value})}
                />
            })}
        </div>}
        {hasHiddenItems && <a role='button' className="el__filter-more" onClick={onExpandClick}>
            {__(!isExpanded ? 'search.filter.showAll' : 'search.filter.hideAll')}
        </a>}
    </React.Fragment>
}